import { getInfo, IEnvironment } from './i-environment';
import { ActiveSports } from './ActiveSports';

export const environment: IEnvironment = {
  version: getInfo().then(({ version }) => version),
  buildNumber: getInfo().then(({ build }) => build),
  activeSports: ActiveSports,
  production: false,
  api: 'https://smatchy-api-dev.amagumolabs.net',
  firebaseConfig: {
    apiKey: "AIzaSyAaiq5ET79I_4Js6KzTo5DyVikZWDOf3qw",
    authDomain: "smatchy-dev-ccf10.firebaseapp.com",
    projectId: "smatchy-dev-ccf10",
    storageBucket: "smatchy-dev-ccf10.firebasestorage.app",
    messagingSenderId: "126567483727",
    appId: "1:126567483727:web:5f943a63e6a2d9cfde5d3a",
    measurementId: "G-Q15NG3Y0EE"
  },
  stripePublishableKey: "pk_test_51SOXFSEMpEbWRIg2btoL6cg1PUtXv382V3sknQdj9TPS3wvlxNz7kbmGTPBTspN3eFuzLwtyu4YpX7Do5JeY1xgr009joJyiW7",
  urlVoteNewSport: 'https://smatchy.quaeso.io/b/4/posts',
  googleApiKey: 'AIzaSyAk65xztUp6dL812cZGxWbNbY2hmsfTQXc',
  packageName : 'com.amagumolabs.smatchy.dev',
  sentryDsn: 'https://6850a19eb748423bc928e9929b2fb4dd@o4511901963517952.ingest.de.sentry.io/4511902062805072',
  smartLinkBaseUrl: 'https://smatchy-app-dev.web.app',
  appLink: {
    uri: 'https://smatchy.page.link'
  },
  ios : {
    appStoreId: '',
    bundleId: ''
  }
};
